const isNullOrUndefined = object => object === undefined || object === null;

export default isNullOrUndefined;
